import { NavigateFunction } from 'react-router';
import { AppDispatch } from 'store/store';
import { baseApi } from 'store/api/base-api';
import { setAuthenticated } from '../auth-slice';

export const userLogout = (
  dispatch: AppDispatch,
  navigate: NavigateFunction,
) => {
  dispatch(setAuthenticated(false));
  navigate('/auth', { replace: true });

  setTimeout(() => {
    dispatch(baseApi.util.resetApiState());
  }, 100);
};
